import { Button, Slide } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import { TransitionProps } from "@mui/material/transitions";
import { ResendOTP } from "otp-input-react";
import React from "react";
import { Spinner } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { resendOTP, verifyInfluncerOTP } from "../../../Apis";
import useAuth from "../../../Contexts/useAuth";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface ModalProps {
  open: boolean;
  handleClose: any;
  handleSubmit: any;
  maxWidth?: any;
  loading?: boolean;
  setLoader?: any;
  mobile?: any;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const renderButton = ({ remainingTime, onClick, ...buttonProps }: any) => (
  <Link
    {...buttonProps}
    className="me-2"
    style={{
      color: "#FF5722",
      pointerEvents: remainingTime !== 0 ? "none" : "auto",
    }}
    onClick={remainingTime === 0 ? onClick : undefined}
  >
    {remainingTime !== 0 ? `Resend in ${remainingTime} sec` : "Resend"}
  </Link>
);

const renderTime = () => React.Fragment;

export default function VerifyInfluncer({
  open,
  handleClose,
  handleSubmit,
  maxWidth,
  loading,
  setLoader,
  mobile,
}: ModalProps) {
  const [otpValue, setOtpValue] = React.useState("");
  const { user } = useAuth();

  const handleVerifyOTP = async (e: any) => {
    e.preventDefault();
    if (!otpValue) {
      toast.error("Please Enter OTP");
      return false;
    } else if (otpValue.length < 4) {
      toast.error("Please Enter 4 Digit OTP");
      return false;
    }
    setLoader(true);
    let params = { mobile_number: mobile, otp: otpValue };
    await verifyInfluncerOTP(params)
      .then((res: any) => {
        setLoader(false);
        if (res?.status) {
          handleCloseModal();
          localStorage.setItem("accessToken", res.data.accessToken);
          handleSubmit();
          // toast.success(res.message);
        }
      })
      .catch((err: any) => {
        setLoader(false);
        setOtpValue("");
        toast.error(err.message);
      });
  };

  const handleResend = async (e: any) => {
    let data = {
      id: user?._id,
    };

    if (e === true) {
      await resendOTP(data)
        .then((res: any) => {
          if (res?.status) {
            toast.success(res?.message);
          } else {
            toast.error(res?.message);
          }
        })
        .catch((err: any) => {
          toast.error(err.message);
        });
    }
  };

  const handleCloseModal = () => {
    setOtpValue("");
    handleClose();
  };

  return (
    <BootstrapDialog
      onClose={handleCloseModal}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth
      TransitionComponent={Transition}
      maxWidth={maxWidth || "xs"}
    >
      <DialogTitle
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
        className="text-center fs-6"
      >
        OTP Verification
      </DialogTitle>
      <DialogContent dividers>
        <p
          className="mt-2 vendor-p"
          style={{ color: "#33333399", textAlign: "center" }}
        >
          Please enter the OTP sent to your email address
        </p>
        <form onSubmit={handleVerifyOTP}>
          <div className="row mt-4 justify-content-center">
            <div className="col-md-8 w-100">
              <div className="otp">
                <OtpInput
                  value={otpValue}
                  inputType="number"
                  onChange={setOtpValue}
                  numInputs={4}
                  renderInput={(props: any) => <input {...props} />}
                  containerStyle={{ justifyContent: "center" }}
                  inputStyle={{
                    width: "50px",
                    textAlign: "center",
                    height: " 50px",
                    border: "1px solid #E0E0E0",
                    padding: " 0px",
                    margin: "0px 5px 20px 10px",
                  }}
                />
              </div>
            </div>
            <div className="col-md-10 w-100">
              <div className="d-flex justify-content-between mx-2">
                <div>
                  <p className="vendor-p">Did not recieve the OTP?</p>
                </div>

                <div>
                  <ResendOTP
                    renderButton={renderButton}
                    renderTime={renderTime}
                    maxTime={30}
                    style={{ color: "white" }}
                    onResendClick={(e: any) => {
                      handleResend(e);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center mt-2">
            <Button
              className="common-btn"
              type="submit"
              variant="contained"
              sx={{ my: 2 }}
            >
              <span className="ms-4 me-4">
                {(loading && <Spinner style={{ height: 15, width: 15 }} />) ||
                  "Confirm"}
              </span>
            </Button>
            <Button
              type="button"
              onClick={handleClose}
              className="ms-2 common-btn bz-btn-secondary"
              variant="contained"
              sx={{ my: 2 }}
            >
              <span className="ms-4 me-4">Cancel</span>
            </Button>
          </div>
        </form>
      </DialogContent>
    </BootstrapDialog>
  );
}
